function padStart(str, maxLength, fillString) {
    if (fillString === void 0) { fillString = ' '; }
    if (str.length >= maxLength) {
        return str;
    }
    var fillLength = maxLength - str.length;
    var fill = fillString.repeat(Math.ceil(fillLength / fillString.length)).substring(0, fillLength);
    return fill + str;
}
function paramPredicate(date) {
    if (!(date instanceof Date) && typeof date !== 'number') {
        throw new TypeError('Invalid Date Value');
    }
    if (typeof date === 'number' && Number.isNaN(date)) {
        throw new TypeError('Invalid Date Value');
    }
    if (date.toString() === 'Invalid Date') {
        throw new TypeError('Invalid Date Value');
    }
}
/**
 * 格式化年份
 * @param time 日期
 * @param simple 是否只取后两位
 */
function formatFullYear(time, simple) {
    var year = time.getFullYear().toString();
    return simple ? year.substring(2, 4) : year;
}
/**
 * 格式化月份
 * @param time 日期
 * @param pad 是否填充
 */
function formatMonth(time, pad) {
    var month = time.getMonth() + 1;
    return pad ? padStart(String(month), 2, '0') : month.toString();
}
/**
 * 通用格式化
 * @param time
 * @param method
 * @param pad
 */
function generalFormat(time, method, pad) {
    var val = time[method]();
    return pad ? padStart(String(val), 2, '0') : val.toString();
}
/**
 * 格式化毫秒
 * @param time
 * @param length
 */
function formatMilliSeconds(time, length) {
    var ms = time.getMilliseconds();
    if (length === 3) {
        return padStart(String(ms), 3, '0');
    }
    if (length === 2) {
        return padStart(String(Math.floor(ms / 10)), 2, '0');
    }
    return Math.floor(ms / 100).toString();
}
var formatFlags = {
    yy: function (val) {
        return formatFullYear(val, true);
    },
    yyyy: function (val) {
        return formatFullYear(val, false);
    },
    YY: function (val) {
        return formatFullYear(val, true);
    },
    YYYY: function (val) {
        return formatFullYear(val, false);
    },
    M: function (val) {
        return formatMonth(val, false);
    },
    MM: function (val) {
        return formatMonth(val, true);
    },
    d: function (val) {
        return generalFormat(val, 'getDate', false);
    },
    dd: function (val) {
        return generalFormat(val, 'getDate', true);
    },
    D: function (val) {
        return generalFormat(val, 'getDate', false);
    },
    DD: function (val) {
        return generalFormat(val, 'getDate', true);
    },
    h: function (val) {
        return generalFormat(val, 'getHours', false);
    },
    hh: function (val) {
        return generalFormat(val, 'getHours', true);
    },
    m: function (val) {
        return generalFormat(val, 'getMinutes', false);
    },
    mm: function (val) {
        return generalFormat(val, 'getMinutes', true);
    },
    s: function (val) {
        return generalFormat(val, 'getSeconds', false);
    },
    ss: function (val) {
        return generalFormat(val, 'getSeconds', true);
    },
    S: function (val) {
        return formatMilliSeconds(val, 1);
    },
    SS: function (val) {
        return formatMilliSeconds(val, 2);
    },
    SSS: function (val) {
        return formatMilliSeconds(val, 3);
    },
};
/**
 * 时间格式化函数
 * @param date
 * @param formatPattern
 */
export function format(date, formatPattern) {
    if (formatPattern === void 0) { formatPattern = 'YYYY-MM-DD'; }
    if (typeof date === 'number') {
        // 判断一下是秒还是毫秒
        if (String(date).length <= 10) {
            date *= 1000;
        }
        date = new Date(date);
    }
    try {
        paramPredicate(date);
    }
    catch (exp) {
        console.error(exp);
        return date;
    }
    return formatPattern
        .replace(/[a-zA-Z]+/g, function (matched) {
        var formatter = formatFlags[matched];
        return typeof formatter === 'function' ? formatter(date) : matched;
    })
        .trim();
}
